var Stylus = {

    init: function() {
        console.log("Stylus init()");
        const ENTER = 13;
        const accordion__header = '.accordion .accordion__item .accordion__header';

        jQuery(accordion__header).each(function() {
            jQuery(this).attr('data-search-term', jQuery(this).text().toLowerCase());
        });

        jQuery('.live-search-box').on('keyup', function() {
            const searchTerm = jQuery(this).val().toLowerCase();
            jQuery(this).closest('.accordions').find(accordion__header).each(function() {
                (jQuery(this).filter('[data-search-term *= ' + searchTerm + ']').length > 0 || searchTerm.length < 1) ?
                jQuery(this).show(): jQuery(this).hide();
            });
        });

        jQuery('input[class=live-search-box]').keydown(function(e) {
            if (e.keyCode == ENTER) {
                e.preventDefault();
                e.stopPropagation();

                const toAdd = jQuery('input[class=live-search-box]').val();
                if (toAdd) {
                    jQuery('<li/>', {
                        'text': toAdd,
                        'data-search-term': toAdd.toLowerCase(),
                    }).appendTo(jQuery('ul'));
                    jQuery('input[class=live-search-box]').val('');
                    console.log('User has entered ' + toAdd);
                }
            }
        });
    }
};